var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 8",
    d: "M9.35254 4.90083C9.35254 7.28337 7.46214 9.19756 5.15127 9.19756C2.8404 9.19756 0.949997 7.28337 0.949997 4.90083C0.949997 2.51829 2.8404 0.604103 5.15127 0.604103C7.46214 0.604103 9.35254 2.51829 9.35254 4.90083Z",
    stroke: "#E6EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M5.78847 2.17519H4.73727L4.83087 5.57359H5.69487L5.78847 2.17519ZM5.24127 6.17119C4.87407 6.17119 4.62207 6.41599 4.62207 6.76879C4.62207 7.12159 4.87407 7.36639 5.24127 7.36639C5.61567 7.36639 5.86047 7.12159 5.86047 6.76879C5.86047 6.41599 5.61567 6.17119 5.24127 6.17119Z",
    fill: "#E6EFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.0f9bf86e4d78b069f679898e3bd111ca.svg";
export { ForwardRef as ReactComponent };